<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Vacinações individualizadas"
        v-if="model && form"
    >
    <rkm-form
        ref="Form"
    >
        <rkm-area>
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            v-if="!edit"
                            :repository="repositories.paciente"
                            :search-fields="autocomplete.paciente"
                            :validations="validations.paciente"
                            :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                            label="Paciente"
                            uppercase
                            v-model="model.paciente"
                        />
                        <rkm-form-input
                            v-else
                            v-model="model.paciente"
                            label="Paciente"
                            disabled
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-input
                            label="Prontuário"
                            v-model="model.prontuario"
                            disabled
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-input
                            label="CNS"
                            v-model="model.cns"
                            disabled
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-input
                            label="CPF"
                            v-model="model.cpf"
                            disabled
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-input
                            label="Sexo"
                            v-model="model.sexo"
                            disabled
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            label="Data de nascimento"
                            v-model="model.nascimento"
                            disabled
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Turno"
                            :options="form.turnos"
                            show-default-option
                            default-option-text="Selecione"
                            text-field="nome"
                            value-field="id"
                            v-model="model.turno"
                            :validations="validations.turno"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Local atendimento"
                            :options="form.locais"
                            show-default-option
                            default-option-text="Selecione"
                            value-field="id"
                            text-field="descricao"
                            v-model="model.local"
                            :validations="validations.local"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-checkbox
                            :label="false"
                            v-model="model.viajante"
                            :disabled="!model.paciente"
                        >
                            Viajante
                        </rkm-form-checkbox>
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-checkbox
                            :label="false"
                            v-model="model.gestante"
                            :disabled="!model.paciente || model.sexo != 'FEMININO'"
                        >
                            Gestante
                        </rkm-form-checkbox>
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-checkbox
                            :label="false"
                            v-model="model.puerpera"
                            :disabled="!model.paciente || model.sexo != 'FEMININO'"
                        >
                            Puérpera
                        </rkm-form-checkbox>
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-checkbox
                            :label="false"
                            v-model="model.hanseniase"
                            :disabled="!model.paciente || !model.vacina || model.vacina.id != 15"
                            :validations="validations.hanseniase"
                        >
                            Comunicante Hanseniase
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
            <rkm-area>
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.vacina"
                            :search-fields="autocomplete.vacina"
                            :request-query-string-params="{origem: 'aplicacao', registro: true, sala_vacinacao_id: additionals.salaVacinacao.id , possui_saldo_estoque: true}"
                            :validations="validations.vacina"
                            :text-field="autocompleteTextField"
                            label="Imunobiológico"
                            v-model="model.vacina"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Estratégia"
                            :options="estrategias"
                            show-default-option
                            default-option-text="Selecione"
                            text-field="nome"
                            value-field="id"
                            :disabled="!model.vacina"
                            v-model="model.estrategia"
                            :validations="validations.estrategia"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Dose"
                            :options="form.doses"
                            show-default-option
                            default-option-text="Selecione"
                            text-field="nome"
                            value-field="id"
                            :disabled="model.estrategia == null"
                            v-model="model.dose"
                            :validations="validations.dose"
                        />
                    </rkm-col>
                </rkm-row>
                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            label="Grupo de atendimento"
                            :options="form.grupos"
                            show-default-option
                            default-option-text="Selecione"
                            text-field="nome"
                            value-field="id"
                            :disabled="!model.estrategia || model.registroAnterior ==  true"
                            v-model="model.grupo"
                            :validations="validations.grupo"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Lote"
                            :options="form.lotes"
                            show-default-option
                            default-option-text="Selecione"
                            text-field="lote"
                            value-field="id"
                            :disabled="!model.vacina"
                            v-model="model.lote"
                            :validations="validations.lote"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Fabricante"
                            :options="form.fabricantes"
                            show-default-option
                            default-option-text="Selecione"
                            text-field="nome"
                            value-field="id"
                            :disabled="model.lote == null"
                            v-model="model.fabricante"
                            :validations="validations.fabricante"
                        />
                    </rkm-col>
                </rkm-row>
                <rkm-row>
                    <rkm-col>
                        <rkm-form-checkbox
                            :label="false"
                            v-model="model.registroAnterior"
                        >
                            Registro Anterior
                        </rkm-form-checkbox>
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-checkbox
                            :label="false"
                            v-model="model.aplicadoExterior"
                            :disabled="!model.registroAnterior"
                        >
                            Aplicado exterior
                        </rkm-form-checkbox>
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-date-picker
                            label="Data do registro anterior"
                            :disabled="!model.registroAnterior"
                            v-model="model.dataAnterior"
                            :max-date="maxDate"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="incluir"
                            :disabled="model.exportado"
                        >
                            Incluir
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>
        <rkm-table
            :fields="fields"
            :items="model.items"
            hide-filters
            hide-pagination
            no-footer-sorting
        >
            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    color="primary"
                    title="Editar"
                    @click="editar(index)"
                    small
                    v-if="edit"
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>

                <rkm-button
                    color="danger"
                    title="Excluir"
                    @click="excluir(item.id, index)"
                    small
                    :disabled="model.exportado"
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>
            </template>
        </rkm-table>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel"> Cancelar </rkm-button>

            <rkm-button
                @click="handleSave"
                color="primary"
                :disabled="!model.items.length"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'
import estrategia from '@/enums/imunizacao/estrategia'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'
import { repository, error, formats, stringCase } from '@/mixins';
import { mapActions } from "vuex";
import moment from 'moment'

export default {
    created() {
        this.repositories = {
            fichaVacinacao: this.getConectaSusRepository('atencaoBasica.fichaVacinacao'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            vacina: this.getConectaSusRepository('cadastro.vacina')
        }
    },
    computed: {
        maxDate() {
            return moment().format('DD/MM/YYYY')
        },
        estrategias() {
            if(this.model.registroAnterior) {
                return this.form.estrategias.filter(estrategia => estrategia.id == this.enums.estrategia.PESQUISA)
            }
            return this.form.estrategias
        },
        autocompleteTextField() {
            let textField = null

            switch (this.additionals.parametrizacaoDescricaoVacina) {
                case this.enums.parametrizacaoDescricaoVacina.ABREVIACAO:
                    textField = 'abreviacao'
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    textField = 'sigla'
                    break;

                default:
                    textField = 'nome'
                    break;
            }

            return textField
        },
        validations() {
            return {
                paciente: {
                    required: true
                },
                turno: {
                    required: true
                },
                local: {
                    required: true
                },
                hanseniase: {
                    required: true
                },
                vacina: {
                    required: true
                },
                estrategia: {
                    required: !this.model.registroAnterior
                },
                dose: {
                    required: !this.model.registroAnterior
                },
                grupo: {
                    required: this.model.estrategia == this.enums.estrategia.CAMPANHA_INDISCRIMINADA || this.model.estrategia == this.enums.estrategia.CAMPANHA_SELETIVA
                },
                lote: {
                    required: true
                },
                fabricante: {
                    required: !this.model.registroAnterior
                },
            }
        },
        autocomplete() {
            return {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
                vacina: [
                    { key: 'nome', searchable: true },
                    { key: 'sigla', searchable: true },
                    { key: 'abreviacao', searchable: true },
                ]
            }
        },
        fields() {
            return [
                {
                    key: "vacina",
                    label: "Imunobiológico",
                    fixed: true
                },
                {
                    key: "estrategia",
                    label: "Estratégia",
                    fixed: true
                },
                {
                    key: "dose",
                    label: "Dose",
                    fixed: true
                },
                {
                    key: "lote",
                    label: "Lote",
                    fixed: true
                },
                {
                    key: "fabricante",
                    label: "Fabricante",
                    fixed: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },

            ]
        }
    },
    data() {
        return {
            id: null,
            edit: false,
            enums: {
                parametrizacaoDescricaoVacina,
                estrategia,
                subclassificacao
            }
        }
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        open(item) {
            if(item) {
                this.id = item.id
                this.edit = true
                this.model.paciente = item.paciente
                this.getPaciente(item.pacienteId)
                this.getVacinas({
                    id: item.id
                })
            } else {
                this.edit = false
            }
            this.clearForm()
            this.model.items = []

            this.$refs.Modal.show()
        },
        getVacinas(id) {
            this.setLoading()
            this.repositories.fichaVacinacao.getVacinas({
                id: id
            })
                .then(({ data }) => {
                    this.model.items = data.items
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getPaciente(id = null) {
            this.setLoading()
            this.repositories.fichaVacinacao.getPaciente({
                paciente_id: id ? id : this.model.paciente.id
            })
                .then(({ data }) => {
                    this.model.prontuario = data.prontuario
                    this.model.cns = data.cns
                    this.model.cpf = data.cpf
                    this.model.sexo = data.sexo
                    this.model.nascimento = data.nascimento
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEstrategias() {
            const request = {
                origem: 'aplicacao',
                vacina_id: this.model.vacina.id,
            }

            this.setLoading()

            this.repositories.fichaVacinacao.getEstrategias(request)
                .then(({ data }) => {
                    if(!data.find(estrategia => estrategia.id == this.model.estrategia)) {
                        this.model.estrategia = null
                    }
                    this.form.estrategias = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getDoses() {
            const request = {
                origem: 'aplicacao',
                vacina_id: this.model.vacina.id,
                estrategia_id: this.model.estrategia,
            }

            this.setLoading()

            this.repositories.fichaVacinacao.getDoses(request)
                .then(({ data }) => {
                    if(!data.find(dose => dose.id == this.model.dose)) {
                        this.model.dose = null
                    }
                    this.form.doses = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getLotes(id = null) {
            this.setLoading()
            this.repositories.fichaVacinacao.getLotes({
                vacina_id: id ? id :this.model.vacina.id
            })
                .then(({ data }) => {
                    this.form.lotes = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getFabricantes(id = null) {
            this.setLoading()
            this.repositories.fichaVacinacao.getFabricantes({
                vacina_id: id ? id : this.model.vacina.id
            })
                .then(({ data }) => {
                    this.form.fabricantes = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        incluir() {
            this.$refs.Form.validate()
                .then(valid => {
                    if(!valid) return

                    let item  = {
                        id: this.edit ? this.model.itemId : null,
                        paciente_id: this.model.paciente.id,
                        turno_id: this.model.turno,
                        local_id: this.model.local,
                        viajante: this.model.viajante,
                        gestante: this.model.gestante,
                        puerpera: this.model.puerpera,
                        hanseniase: this.model.hanseniase,
                        vacina_id: this.model.vacina.id,
                        vacina: this.model.vacina.nome,
                        estrategia_id: this.model.estrategia,
                        estrategia: this.form.estrategias.find(estrategia => estrategia.id == this.model.estrategia).nome,
                        dose_id: this.model.dose,
                        dose: this.form.doses.find(dose => dose.id == this.model.dose).nome,
                        grupo_id: this.model.grupo,
                        entrada_id: this.model.lote,
                        lote: this.form.lotes.find(lote => lote.id == this.model.lote).lote,
                        fabricante_id: this.model.fabricante,
                        fabricante: this.form.fabricantes.find(fabricante => fabricante.id == this.model.fabricante).nome,
                        registro_anterior: this.model.registroAnterior,
                        aplicado_exterior: this.model.aplicadoExterior,
                        data: this.model.dataAnterior ? moment(this.model.dataAnterior).format('YYYY-MM-DD') : null,
                        ultimo_frasco: false,
                        save: true
                    }

                    if(this.additionals.usaUltimoFrasco) {
                        this.showConfirmation(
                            'Ultima aplicação do frasco?',
                            async () => {
                                if(this.edit && this.model.items.find(item => item.id == this.model.itemId)) {
                                    this.model.items = this.model.items.filter(item => item.id != this.model.itemId)
                                }

                                item.ultimo_frasco = true
                                this.model.items.push(item)
                                this.clearForm()
                            },
                            async () => {
                                if(this.edit && this.model.items.find(item => item.id == this.model.itemId)) {
                                    this.model.items = this.model.items.filter(item => item.id != this.model.itemId)
                                }

                                this.model.items.push(item)
                                this.clearForm()
                            })
                    } else {
                        if(this.edit && this.model.items.find(item => item.id == this.model.itemId)) {
                            this.model.items = this.model.items.filter(item => item.id != this.model.itemId)
                        }

                        this.model.items.push(item)
                        this.clearForm()
                    }
                })
        },
        editar(index) {
            let item = this.model.items[index]
            this.model.itemId = item.id
            this.model.turno = item.turno
            this.model.local = item.local
            this.model.viajante = item.viajante
            this.model.gestante = item.gestante
            this.model.puerpera = item.puerpera
            this.model.hanseniase = item.hanseniase
            this.model.vacina = {
                id: item.vacinaId ?? item.vacina_id,
                nome: item.vacina
            }
            this.model.estrategia = item.estrategiaId ?? item.estrategia_id
            this.model.dose = item.doseId ?? item.dose_id
            this.model.grupo = item.grupoId ?? item.grupo_id
            this.getLotes(item.vacinaId ?? item.vacina_id)
            this.model.lote = item.loteId ?? item.entrada_id
            this.getFabricantes(item.vacinaId ?? item.vacina_id)
            this.model.fabricante = item.fabricanteId ?? item.fabricante_id
            this.model.registroAnterior = item.registroAnterior ?? item.registro_anterior
            this.model.aplicadoExterior = item.aplicadoExterior ?? item.aplicado_exterior
            this.model.dataAnterior = item.data
        },
        excluir(id, index) {
            if(id) {
                const destroy = async () => {
                    this.setLoading()
                    this.repositories.fichaVacinacao.destroyOne(id)
                        .then(() => {
                            this.model.items = this.model.items.filter(item => item.id != id)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
                this.showDeleteConfirmation(
                    'Deseja realmente excluir a vacina?',
                    destroy,
                    this.handleError
                )
            } else {
                this.model.items.splice(index, 1)
            }
        },
        handleSave() {
            if(this.edit) {
                this.setLoading()
                this.repositories.fichaVacinacao.update(this.id, this.prepareItems())
                    .then(() => {
                        this.showSaveNotification()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.setLoading()
                this.repositories.fichaVacinacao.store(this.prepareData())
                    .then(() => {
                        this.showSaveNotification()
                            this.$emit("update:model", {
                                ...this.model,
                                items: []
                            });
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        prepareData() {
            return {
                id: this.model.id,
                usuario_id: this.model.usuario.id,
                unidade_id: this.model.unidadeId,
                ocupacao_id: this.model.ocupacaoId,
                equipe_id: this.model.equipeId,
                data: moment(this.model.data).format('YYYY-MM-DD'),
                items: this.prepareItems()
            }
        },
        prepareItems() {
            if(this.edit) {
                return this.model.items.filter(item => item.save)
            } else {
                return this.model.items
            }
        },
        clearForm() {
            if(!this.edit) {
                this.model.paciente = null
                this.model.prontuario = null
                this.model.cns = null
                this.model.cpf = null
                this.model.sexo = null
                this.model.nascimento = null
            }
            this.model.turno = null
            this.model.local = null
            this.model.itemId = null
            this.model.viajante = false
            this.model.gestante = false
            this.model.puerpera = false
            this.model.hanseniase = false
            this.model.vacina = null
            this.model.estrategia = null
            this.model.dose = null
            this.model.grupo = null
            this.model.lote = null
            this.model.fabricante = null
            this.model.registroAnterior = false
            this.model.dataAnterior = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    watch: {
        "model.paciente" () {

            if (!this.model.paciente) {
                this.clearForm()
            }

            if(this.model.paciente && !this.edit) {

                this.setLoading()

                this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: this.model.paciente.id}))
                    .then(response => {

                        if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                            this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                            this.clearForm()
                            return false
                        }

                        if (this.model.paciente.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                            && response.data.additionals.avisaCnsTemporarioInvalido) {

                                const confirm = async () => {

                                    this.getPaciente()
                                    return false
                                }

                                const cancel = async () => {

                                    this.clearForm()
                                    return false
                                }

                                const msg = `Paciente com cadastro temporário. Deseja continuar?`

                                this.showConfirmation(msg, confirm, cancel)

                                return false
                        }

                        this.getPaciente()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        "model.gestante" () {
            if(this.model.gestante) {
                this.model.puerpera = false
            }
        },
        "model.puerpera" () {
            if(this.model.puerpera) {
                this.model.gestante = false
            }
        },
        "model.vacina" () {
            if(this.model.vacina) {
                this.getEstrategias()
                this.getLotes()
            }
        },
        "model.estrategia" () {
            if(this.model.estrategia) {
                this.getDoses()
            }
        },
        "model.lote" () {
            if(this.model.lote) {
                this.getFabricantes()
            }
        },
        "model.registroAnterior" () {
            if(!this.model.registroAnterior) {
                this.model.aplicadoExterior =  false
                this.model.dataAnterior = null
            }
        }
    },
    mixins: [ repository, error, formats, stringCase ],
    props: {
        model: { type: Object, required: true },
        form: { type: Object, required: true },
        items: { type: Array },
        additionals: { type: Object, required: true }
    }
}
</script>